import axios from 'axios';
import authHeader from "../auth-header";
import ConstApiUrls from "../const-api-urls";

const API_URL = ConstApiUrls.API_SERVICE_URL

class FKomoditiTypeService {
    getApiUrl() {
        return API_URL
    }
    getAllFKomoditiTypePublic(){
        return axios.get(API_URL + `public/getAllFKomoditiTypePublic`, { headers: authHeader() });
    }
    getAllFKomoditiType(){
        return axios.get(API_URL + `getAllFKomoditiType`, { headers: authHeader() });
    }
    getAllFKomoditiTypeByOrgLevel(){
        return axios.get(API_URL + `getAllFKomoditiTypeByOrgLevel`, { headers: authHeader() });
    }

    getAllFKomoditiTypeContaining(page, pageSize, sortBy, order, search, lang){
        // return axios.get(API_URL + `getAllFKomoditiType`, { headers: authHeaderMultipart() });
        return axios.get(API_URL + `getAllFKomoditiTypeContaining?page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&order=${order}&search=${search}&lang=${lang}`, { headers: authHeader() });
    }
    getFKomoditiTypeById(id){
        return axios.get(API_URL + `getFKomoditiTypeById/${id}`, { headers: authHeader() });
    }
    getFKomoditiTypeByBaseId(baseId, lang){
        return axios.get(API_URL + `getFKomoditiTypeByBaseId/${baseId}?lang=${lang}`, { headers: authHeader() });
    }
    updateFKomoditiType(item){
        return axios.put(API_URL + `updateFKomoditiType/${item.id}`, item, {headers: authHeader()})
    }
    createFKomoditiType(item){
        return axios.post(API_URL + `createFKomoditiType`, item, {headers: authHeader()})
    }
    createFKomoditiTypeMultiple(items){
        return axios.post(API_URL + `createFKomoditiTypeMultiple`, items, {headers: authHeader()})
    }
    deleteFKomoditiType(id){
        return axios.delete(API_URL + `deleteFKomoditiType/${id}`, {
            headers: authHeader()
        });
    }
    deleteAllFKomoditiType(itemIds){
        // let user = JSON.parse(localStorage.getItem('user'));
        // return axios.delete(API_URL + `deleteAllFKomoditiType`, {
        //     headers:  authHeaderMultipart(),
        //     data: {
        //         message: 'delete  success'
        //     }
        // });
        return axios.delete(API_URL + `deleteAllFKomoditiType`, {
            headers:  authHeader(),
            data: itemIds
        });


    }
}
export default new FKomoditiTypeService()